import React, { useState } from 'react';
import styles from './MarkeraButton.module.css';
import classNames from 'classnames';

import { TouchApp } from '@mui/icons-material';
import { useKartstodContext } from '../contexts/KartstodContext';
import ModalInfotext from '../ModalInfotext';
import { usePremiumContext } from '../contexts/PremiumContext';

const MarkeraButton: React.FC = () => {
  const {
    isMarkeraAktiv,
    setIsMarkeraAktiv,
    setRitverktyg,
    setGeometri,
    setIsRitverktygAktiv,
  } = usePremiumContext();
  const {
    setIsRitverktygOpen,
    setIsInstallningarOpen,
    setIsSokKoordinaterOpen,
  } = useKartstodContext();
  const [visaHjalpRuta, setVisaHjalpRuta] = useState(false);

  const togglaMarkera = () => {
    if (isMarkeraAktiv) {
      setGeometri('pin');
    } else {
      setGeometri('');
    }

    setIsMarkeraAktiv(!isMarkeraAktiv);
    setIsInstallningarOpen(false);
    setIsRitverktygOpen(false);
    setIsSokKoordinaterOpen(false);
    setVisaHjalpRuta(false);
    setRitverktyg({
      isLinje: false,
      isCirkel: false,
      isPolygon: false,
      isPin: false,
    });
    setIsRitverktygAktiv(false);
  };

  const hovraMarkeraButton = () => {
    setVisaHjalpRuta(true);
  };

  const doljHjalpRuta = () => {
    setVisaHjalpRuta(false);
  };

  return (
    <>
      {visaHjalpRuta ? (
        <ModalInfotext
          meddelande={'Markera hämtade fastigheter i kartan'}
          style={{ top: '5px', width: '205px' }}
        />
      ) : null}
      <div className={classNames(styles.markeraContainer)}>
        <div
          className={classNames(
            styles.settingsTool,
            isMarkeraAktiv ? styles.activeTool : ''
          )}
          onMouseEnter={() => hovraMarkeraButton()}
          onMouseLeave={() => doljHjalpRuta()}
          onClick={togglaMarkera}
        >
          <TouchApp />
        </div>
      </div>
    </>
  );
};

export default MarkeraButton;
